import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  // 初始化的数据
  state: {
    login: false,

    // 快捷认证
    agency: null,
  },
  // 改变state里面的值得方法
  mutations: {
    setLogin(state, val) { state.login = val; },
    setAgency(state, val) { state.agency = val; },
  },
  actions: {},
  getters: {}
});
// 输出模块
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js